/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Crumb_OnlineInputs */

const en_vc_crumb_online = /** @type {(inputs: Vc_Crumb_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const zh_vc_crumb_online = /** @type {(inputs: Vc_Crumb_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线版`)
};

/**
* | output |
* | --- |
* | "Online" |
*
* @param {Vc_Crumb_OnlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_crumb_online = /** @type {((inputs?: Vc_Crumb_OnlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Crumb_OnlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_crumb_online(inputs)
	return zh_vc_crumb_online(inputs)
});
export { vc_crumb_online as "vc.crumb.online" }